var _g, _path, _path2, _path3;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgCircleCancelRed(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 32,
    height: 32,
    viewBox: "0 0 1024 1024",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "icomoon-ignore"
  })), _path || (_path = /*#__PURE__*/React.createElement("path", {
    fill: "#f44336",
    d: "M1024 512c0 282.756-229.244 512-512 512-282.752 0-512-229.244-512-512 0-282.752 229.248-512 512-512 282.756 0 512 229.248 512 512z"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    fill: "#fff",
    d: "M656.788 294.809l72.397 72.397-361.984 361.984-72.397-72.397 361.984-361.984z"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    fill: "#fff",
    d: "M729.185 656.793l-72.397 72.397-361.984-361.984 72.397-72.397 361.984 361.984z"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgCircleCancelRed);
export default __webpack_public_path__ + "static/media/circle-cancel-red.032a84209d2f960986d3d1d24b5043ab.svg";
export { ForwardRef as ReactComponent };